import { useProcessState } from '~/store'
import { Organization } from '@st/sdk'
import { organizationModule } from './organization-module'

export function useOrganization(): Organization {
  const organization = useProcessState(organizationModule, (s) => s.organization)
  if (!organization) throw 'Organization not loaded'
  return organization
}
